var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36963",
    "data-name": "Path 36963",
    d: "M0,0H16V16H0Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36964",
    "data-name": "Path 36964",
    d: "M8.316,1.318a7,7,0,1,1-7,7,7,7,0,0,1,7-7ZM6.863,10.592,5.149,8.876A.75.75,0,0,1,6.209,7.816L7.418,9.025l3.006-3.006A.75.75,0,0,1,11.484,7.08L7.947,10.617a.752.752,0,0,1-1.061,0l-.024-.025Z",
    transform: "translate(-0.313 -0.314)",
    fill: "#02d8a0",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.135d1b532137ba2ad23cc72c0df89d04.svg";
export { ForwardRef as ReactComponent };